import { RG_TYPE } from '../../types/rg-type.js';

const DefaultEmptySpace = {
    type: RG_TYPE.EmptySpace,
    name: 'empty space',
    color: '#C1B2AC',
    size: [2, 2, 2],
    anchor: [0.5, 0, 0.5],
    children: [],
    data: { level: -1, levelId: '' }
};

export { DefaultEmptySpace };
//# sourceMappingURL=default-empty-space.js.map
